import CONSTANTS from "../constants";
import { isValidEmail } from "../emailValidation";

export const validateEmail = (email: string, needApply: boolean = false) => {
  let emailErrorMessage = "";
  let apply = true;

  // メール形式チェックは CRM と統一（isValidEmail / EMAIL_PATTERN）。
  // 旧実装の「半角のみ」チェックは Unicode ローカル部を許可する統一ルールに合わせて撤廃。
  if (email && !isValidEmail(email)) {
    emailErrorMessage = "メールアドレスの形式で入力してください";
    apply = false;
  } else if (email && email.length > CONSTANTS.MAX_LENGTH.EMAIL) {
    emailErrorMessage = "255文字以下で入力してください";
    apply = false;
  }

  return needApply ? { emailErrorMessage, apply } : { emailErrorMessage };
};
